import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { getImageUrl } from "../../../config/s3Config"
import "./header.css"

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50
      setScrolled(isScrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  // Allow ESC to close mobile menu
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  const isActive = (path) => location.pathname === path

  return (
    <>
      {/* <Head /> */}
      <header className={`header-main ${scrolled ? 'scrolled' : ''}`}>
        <nav className='nav-container' aria-label="Main navigation">
          <div className='nav-brand'>
            <Link to='/' aria-label="Go to home" className="brand-link">
              <div className='brand-logo'>
                <picture className="brand-picture">
                  <source srcSet={getImageUrl("/images/logos/sdti.png")} media="(min-width:768px)" />
                  <img src={getImageUrl("/images/logos/sdti.png")} className="logo-primary" alt="SDTI primary logo" loading="lazy" />
                </picture>
                <img src={getImageUrl("/images/logos/Logo---EDU (2).png")} className="logo-secondary" alt="SDTI education emblem" loading="lazy" />
                <span className='brand-text sr-only'>SDTI</span>
              </div>
            </Link>
          </div>

          <ul className={`nav-menu ${menuOpen ? 'nav-menu-active' : ''}`} role="menubar">
            <li className={`nav-item ${isActive('/') ? 'active' : ''}`} role="none">
              <Link role="menuitem" tabIndex={0} to='/'>Home</Link>
            </li>
            <li className={`nav-item ${isActive('/courses') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/courses'>Schools</Link>
            </li>
            <li className={`nav-item ${isActive('/branch') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/branch'>Branch</Link>
            </li>

            <li className={`nav-item ${isActive('/about') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/about'>About</Link>
            </li>
            <li className={`nav-item ${isActive('/team') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/team'>Team</Link>
            </li>
            <li className={`nav-item ${isActive('/journal') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/journal'>Blog</Link>
            </li>
            <li className={`nav-item ${isActive('/contact') ? 'active' : ''}`} role="none">
              <Link role="menuitem" to='/contact'>Contact</Link>
            </li>
            <li className='nav-item nav-item-cta mobile-only' role="none">
              <Link role="menuitem" to='/contact'>Apply Now</Link>
            </li>
          </ul>

          <div className='nav-actions'>
            <div className='cta-button desktop-only'>
              <Link to='/contact'>Apply Now</Link>
            </div>
            <button
              className={`hamburger ${menuOpen ? 'active' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
              aria-expanded={menuOpen}
              aria-controls='primary-navigation'
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </nav>
        <div className='header-gradient-bar' aria-hidden='true'></div>
      </header>
    </>
  )
}

export default Header
